import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_select, _mergeProps({
      modelValue: _ctx.selectedValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedValue) = $event))
    }, _ctx.$attrs, {
      options: _ctx.options,
      "use-input": "",
      "fill-input": "",
      "hide-selected": "",
      "emit-value": "",
      "map-options": "",
      onFilter: _ctx.filterFn
    }), _createSlots({ _: 2 }, [
      (_ctx.selectedValue != null)
        ? {
            name: "append",
            fn: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "cancel",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectedValue = null), ["stop","prevent"])),
                class: "cursor-pointer"
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1040, ["modelValue", "options", "onFilter"])
  ]))
}